import { requestAnimationFrame } from 'DistributionPackages/GesagtGetan.Basic/Resources/Private/Assets/Helper';

window.requestAnimationFrame = requestAnimationFrame;

let windowHeight = window.innerHeight;
let isScroll = false;
let latestScroll = 0;
let blur = null;
let headline = null;

function updateWindowHeight() {
    windowHeight = window.innerHeight;
}

function checkScroll() {
    if (!isScroll) {
        window.requestAnimationFrame(update);
    }
    isScroll = true;
}

function update() {
    let currentScroll = latestScroll;
    isScroll = false;

    if (headline && headline.length) {
        let scroll = currentScroll / 4;
        for (let i = 0; i < headline.length; i++) {
            headline[i].style.transform = 'translate3d(0,' + scroll + 'px,0)';
        }
    }

    if (blur && blur.length) {
        let scroll = currentScroll * 6;
        let filter = (scroll / windowHeight).toFixed(1);
        filter = filter <= 0 ? 0 : filter;
        for (let i = 0; i < blur.length; i++) {
            blur[i].style.filter = 'blur(' + filter + 'px)';
        }
    }
}

export default function(settings) {
    let swiper = false;
    if (settings.selector) {
        swiper = document.querySelector(settings.selector);
    }

    if (swiper) {
        if (settings.headline) {
            headline = swiper.querySelectorAll('.swiper-headline');
        }

        if (settings.blur) {
            blur = swiper.querySelectorAll('.swiper-blur');
        }

        if ((settings.headline && headline) || (settings.blur && blur)) {
            window.addEventListener(
                'scroll',
                () => {
                    latestScroll = window.scrollY;
                    checkScroll();
                },
                false
            );
            window.addEventListener('resize', updateWindowHeight, false);
        }
    }
}
